module.exports = __webpack_public_path__ + "img/projek-katsys8.1d978136.png";